export {
  ELEVATION_ATTR,
  ELEVATION_SELECTOR,
  getElevation,
  useCurrentElevation,
  registerClickOutsideHandler,
  unregisterClickOutsideHandler,
  getHighestVisibleElevation,
  reset,
} from './src/layerManager';

export { useCallbackRef } from './src/useCallbackRef';
